/* tslint:disable */
/* eslint-disable */
/**
 * Scality Guardian Backend
 *
 * The version of the OpenAPI document: 0.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  InstancesResponse,
} from '../models/index';
import {
    InstancesResponseFromJSON,
    InstancesResponseToJSON,
} from '../models/index';

/**
 * 
 */
export class InstancesApi extends runtime.BaseAPI {

    /**
     * Get the list of Guardian instance IDs that the authenticated user has access to.  Args:     current_user: Authenticated user information  Returns:     InstancesResponse: List of instance IDs the user can access  Note:     Scality users (Internal role with @scality.com/@scality.fr email) have access to all instances,     while external users only have access to their specific assigned instances.
     * Get Instances
     */
    async getInstancesApiV1InstancesGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InstancesResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/instances/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InstancesResponseFromJSON(jsonValue));
    }

    /**
     * Get the list of Guardian instance IDs that the authenticated user has access to.  Args:     current_user: Authenticated user information  Returns:     InstancesResponse: List of instance IDs the user can access  Note:     Scality users (Internal role with @scality.com/@scality.fr email) have access to all instances,     while external users only have access to their specific assigned instances.
     * Get Instances
     */
    async getInstancesApiV1InstancesGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InstancesResponse> {
        const response = await this.getInstancesApiV1InstancesGetRaw(initOverrides);
        return await response.value();
    }

}
